// services/produtos.js
import axiosInstance from './axiosInstance';

const PRODUTOS_API_URL = '/produtos';

const produtosService = {
  async get(idempresa, descricaocategoria = '') {
    try {
      const categoriaParam = descricaocategoria ? `&descricaocategoria=${encodeURIComponent(descricaocategoria)}` : '';
      const response = await axiosInstance.get(`${PRODUTOS_API_URL}/get.php?idempresa=${idempresa}${categoriaParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      return [];
    }
  }
};

export default produtosService;
